import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import { spacing } from '@decisiv/design-tokens';
import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const DepotCardWrapper = styled(Flex)`
  align-items: center;
  padding: ${rem(spacing.base)};
  gap: ${rem(spacing.base)};
  background-color: ${toColorString(color.base.fullMoon)};
`;
